import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalErrorService } from '@services/global-error.service';
import { jobDtlsResponse } from '@interfaces/job-details.model';
import { catchError, Observable, switchMap } from 'rxjs';
import { environment } from '@environments/environment';
import { VendorService } from '@services/vendor.service';

@Injectable({
  providedIn: 'root',
})
export class VendorRepJobDetailsService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService,
    private vendorService: VendorService,
  ) {}

  getJobDetails(hiringRequestId: number): Observable<jobDtlsResponse> {
    return this.vendorService.currentVendor$.pipe(
      switchMap((currentVendor: any) => {
        const vendorId = currentVendor?.id;
        return this.http
          .get<jobDtlsResponse>(
            `${this.baseUrl}/vendor/open-positions/${hiringRequestId}?vendorId=${vendorId}`,
          )
          .pipe(
            catchError((error) => {
              return this.errorHandler.logError(error);
            }),
          );
      }),
    );
  }
}
